var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.65 27.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c0c0c;}.cls-2{fill:#9ca5ad;}.cls-3{fill:none;stroke:#9ca5ad;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.82,
    cy: 13.82,
    r: 12.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.82,27.65A13.83,13.83,0,1,1,27.65,13.82,13.84,13.84,0,0,1,13.82,27.65Zm0-25.52a11.7,11.7,0,1,0,11.7,11.69A11.7,11.7,0,0,0,13.82,2.13Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "11.94 9.39 18.26 9.39 18.26 15.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 9.39,
    y1: 18.26,
    x2: 18.26,
    y2: 9.39
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLight);
export default __webpack_public_path__ + "static/media/arrow_light.3dcf21ad9560eff6252d272eab0f223c.svg";
export { ForwardRef as ReactComponent };